<template>
  <div class="animated-line">
    <slot></slot>
    <div class="animated-line--container">
      <div
        v-if="!rainbow"
        ref="animatedbar"
        class="animated-line--bar"
        :style="{ backgroundColor: dynamicColor }"
      ></div>
      <div v-if="rainbow" ref="animatedbar" class="animated-line--bar with-rainbow"></div>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce';

export default {
  name: 'animatedline',
  props: {
    dynamicColor: { type: String, required: false },
    rainbow: { type: Boolean, default: false },
  },
  data() {
    return {
      bounding: 0,
      offset: window.innerHeight / 2,
      scroll: true,
    };
  },
  created() {
    window.addEventListener('scroll', debounce(this.handleScroll, 10));
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    setBounding() {
      this.bounding = this.$el.getBoundingClientRect();
      this.height = this.bounding.bottom - this.bounding.top;
    },
    handleScroll() {
      if (!this.scroll) {
        return;
      }
      this.setBounding();
      const begin = this.bounding.top <= this.offset;
      const end = this.bounding.top >= -this.height;
      this.currentBar = this.$refs.animatedbar;
      const height = ((-this.bounding.top + this.offset) / this.height) * 100;
      if (height >= 100) {
        window.removeEventListener('scroll', this, true);
        this.scroll = false;
      }
      if (begin && end) {
        this.currentBar.style.height = `${Math.round(height)}%`;
      } else if (this.bounding.top >= -this.height) {
        this.currentBar.style.height = '0';
      }
    },
  },
};
</script>
